import { useContext } from 'react';

import { PlaceProviderContext } from './index';

const usePlace = () => {
	const { state, loadError } = useContext(PlaceProviderContext);

	return { place: state, loadError };
};

export default usePlace;
